import React, { memo } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-320">
      <div className="max-w-3xl mx-auto" data-id="element-321">
        <div ref={fadeIn.ref} className={`space-y-6 md:space-y-8 text-base md:text-xl ${fadeIn.className}`} data-id="element-322">
          <div className="text-center mb-8 md:mb-12" data-id="element-323">
            <h2 className="text-2xl md:text-4xl font-black text-yellow-400 mb-4 md:mb-6" data-id="element-324">
              💔 ¿Cuántos días más vas a pasar sin saber cómo ayudar?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-325">
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-326">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-327">🌋</div>
              <p className="text-gray-300 font-medium" data-id="element-328">
                Tu hijo explota o se bloquea y no sabés qué hacer en ese momento
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-329">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-330">💥</div>
              <p className="text-gray-300 font-medium" data-id="element-331">
                Querés hablar con él/ella pero cada conversación termina en
                pelea o silencio
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-332">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-333">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-334">
                Ves que las redes lo/la afectan pero no tenés cómo abordarlo sin
                que se ponga defensivo/a
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-335">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-336">😰</div>
              <p className="text-gray-300 font-medium" data-id="element-337">
                La ansiedad y el estrés escolar están ahí y no tenés un
                protocolo claro para ayudar
              </p>
            </div>
          </div>

          <div className="text-center mt-8 md:mt-12 space-y-3 md:space-y-4" data-id="element-338">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-339">
              No es falta de amor. Es falta de herramientas. ❤️
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-340">
              Querés acompañar a tu hijo o a tus alumnos. Pero nadie te enseñó
              cómo.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-3 md:mt-4" data-id="element-341">
              Nadie te enseñó cómo hablar de emociones sin que se cierren, cómo
              manejar una crisis sin explotar vos también, o cómo ayudarlos a
              tomar decisiones sin que sientan que los controlás.
            </p>
          </div>

          <div className="bg-gray-900 p-6 md:p-8 rounded-xl border border-yellow-500 mt-8 md:mt-12 shadow-2xl" data-id="element-342">
            <div className="space-y-4 md:space-y-6 text-gray-300" data-id="element-343">
              <p className="flex items-start gap-3" data-id="element-344">
                <span className="text-xl md:text-2xl" data-id="element-345">🔑</span>
                <span className="font-bold text-white" data-id="element-346">
                  Lo que necesitás es un sistema completo de gestión emocional
                  adolescente, listo para usar desde el primer día.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-347">
                <span className="text-xl md:text-2xl" data-id="element-348">📔</span>
                <span data-id="element-349">
                  Con Mi Espacio Interior vas a tener 6 tomos + 6 bonos con +500
                  páginas de herramientas, ejercicios y guías.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-350">
                <span className="text-xl md:text-2xl" data-id="element-351">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-352">
                  ¿Y si hoy fuera el último día que pasás sin saber cómo ayudar?
                  💙
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}